import React, {useState, useCallback, useEffect} from 'react';
import {
  Form,
  FormLayout,
  Page,
  Card,
  Button,
  TextField,
  Select
} from '@shopify/polaris';
import {
  getDeliveryEstimateSettings,
  updateDeliveryEstimateSettings
 } from '../../services/deliveryEstimate';

export default function DeliveryTimeSettings() {
  const primaryAction = {content: 'Back', url: '/'};

  const [deliveryEstimateMsg, setDeliveryEstimateMsg] = useState('Delivery between {de_start} and {de_end}. Order within {de_time}.');
  const [placementSelector, setPlacementSelector] = useState('[form="/cart/add.js"]');
  const [placementPosition, setPlacementPosition] = useState('After');
  const [settings, setSettings] = useState<any>({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleSubmit = useCallback(() => {
    const _settings = {
      message: deliveryEstimateMsg,
      selector: placementSelector,
      position: placementPosition,
    };
    updateDeliveryEstimateSettings(_settings);
  }, []);

  const handleMessageChange = useCallback((newValue) => {
    setDeliveryEstimateMsg(newValue);
    updateDisabledButtonState();
  }, []);
  const handlePlacementSelectorChange = useCallback((newValue) => {
    setPlacementSelector(newValue);
    updateDisabledButtonState();
  }, []);
  const handlePlacementPosition = useCallback((newValue) => {
    setPlacementPosition(newValue);
    updateDisabledButtonState();
  }, []);

  const updateDisabledButtonState = () => {

    /*let isBtnDisabled = true;
    if (
      settings.hasOwnProperty('message') && settings['message'] !== deliveryEstimateMsg
      || settings.hasOwnProperty('selector') && settings['selector'] !== placementSelector
      || settings.hasOwnProperty('position') && settings['position'] !== placementPosition) {
      isBtnDisabled = false;
    }*/

    //console.log(settings, isBtnDisabled)
    setIsButtonDisabled(false);
  }

  useEffect(() => {
    getDeliveryEstimateSettings().then((settings) => {
      setSettings(settings);

      if (settings.hasOwnProperty('message')) {
        setDeliveryEstimateMsg(settings.message);
      }
      if (settings.hasOwnProperty('selector')) {
        setPlacementSelector(settings.selector);
      }
      if (settings.hasOwnProperty('position')) {
        setPlacementPosition(settings.position);
      }
    });
  }, []);

  return (
    <Page
    title="Delivery Estimate Settings"
    primaryAction={primaryAction}
  >
    <Card sectioned>
      <Form onSubmit={handleSubmit}>
        <FormLayout>
          <TextField
            value={deliveryEstimateMsg}
            onChange={handleMessageChange}
            label="Message"
            type="text"
            helpText={
              <span>
                We’ll use this text to display the delivery estimate on the product page.
              </span>
            }
          />

          <FormLayout.Group condensed>
            <TextField
              label="Placement Selector"
              type="text"
              value={placementSelector}
              onChange={handlePlacementSelectorChange}
            />
            <Select
              label="Placement Position"
              placeholder="Select"
              options={['Before', 'After']}
              value={placementPosition}
              onChange={handlePlacementPosition}
            />
          </FormLayout.Group>
        </FormLayout>
      </Form>
    </Card>
    <Card sectioned>
      <Button
        loading={isUpdating}
        disabled={isButtonDisabled}
        onClick={handleSubmit}
        primary>Update</Button>
    </Card>
  </Page>
  );
}
